<template>
<div class="audioEdit bgc">
    <div class="message" v-if="!realName">
        <el-alert title="" type="warning" show-icon :closable="false">请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。</el-alert>
    </div>
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
            <div class="classes blod">基本信息</div>
            <el-form-item label="音频名称" prop="subject" class="videoName">
                <el-input v-model.trim="item.subject" placeholder="请输入音频名称，不超过45个字" maxlength="45" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="音频上传" prop="audioinfo" class="upload-file" required>
                <div class="upload-display" v-if="item.audioinfo.furl">
                    <span>{{item.audioinfo.fname}}</span><span class="el-upload__tip">{{fsize(item.audioinfo.fsize)}}</span>
                    <el-button type="text" size="small" @click="delUploadVidoe">删除</el-button>
                </div>
                <div class="el-upload__tip" style="margin: 0; margin-bottom: 10px">
                    <div>格式支持mp3、m4a，为保证音频加载与播放的流畅性，建议上传大小不超过500M</div>
                </div>
                <div class="upload-file-btn">
                    <uploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                    <!-- <el-button type="warning" @click="openVideoScrollBox">素材库</el-button> -->
                </div>
            </el-form-item>

            <el-form-item label="音频封面" prop="coverPicture" class="upload-image" required>
                <upload class="headImage" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                <div class="el-upload__tip">
                    <el-button type="warning" @click="openCoverScrollBox">素材库</el-button>
                    <div>音频封面是指在商品列表展示的图片。建议尺寸750*420px，JPG、PNG格式， 图片小于5M。 </div>
                </div>
            </el-form-item>
            <el-form-item label="音频详情">
                <uEditor :content="item.content" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
            </el-form-item>
            <div class="classes blod">商品信息</div>
            <el-form-item label="售卖方式">
                <promotionMsg ref="promotionMsg" @changeWay="changeWay"></promotionMsg>
            </el-form-item>
            <el-form-item label="商品分组" prop="description" class="shopGroup">
                <el-select v-model="item.divisionids" multiple placeholder="请选择" collapse-tags clearable>
                    <el-option v-for="item in shopGroupList" :key="item.innerid" :label="item.name" :value="item.innerid"> </el-option>
                </el-select>
                <el-button class="refresh" type="text" size="small" @click="_getShopGroupList">刷新</el-button>
                <el-button type="text" size="small" @click="goToShopGroup">前往商品分组</el-button>
            </el-form-item>
            <div class="classes blod">上架设置</div>
            <el-form-item label="上架方式" prop="onlinetype" label-width="120px" class="onLineSet">
                <!--<el-radio-group v-model="item.onlinetype" @change="switchStatus">-->
                    <!--<el-radio :label="onlinetype.code" v-for="(onlinetype, index) in onlinetypeList" :key="index">-->
                        <!--{{onlinetype.name}}-->
                        <!--<el-date-picker v-if="onlinetype.code == 2" v-model="item.onlinetime" type="datetime" placeholder="选择日期" :disabled="item.onlinetype != 2"-->
                                        <!--format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>-->
                    <!--</el-radio>-->
                <!--</el-radio-group>-->
                <!--<el-collapse class="setting">-->
                    <!--<el-collapse-item title="高级设置" name="1">-->
                        <!--<el-checkbox v-model="item.ispublic"><span>店铺内公开</span><span class="tip">上架的商品取消公开后，在店铺内不显示，但可以通过链接的方式访问</span></el-checkbox>-->
                        <!--<el-checkbox v-model="item.isplatform"><span>平台发布</span><span class="tip">官网发布，快速提高曝光率和增加浏览量</span></el-checkbox>-->
                    <!--</el-collapse-item>-->
                <!--</el-collapse>-->
                <shalfSetting :item="item"></shalfSetting>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">提交</el-button>
                <el-button type="" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
    <scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="setMaterialCoverfile"></scrollBox>
    <scrollBox ref="videoScrollBox" :uploadType="uploadVideoType" @saveMaterialFile="setMaterialVideofile"></scrollBox>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import UEditor from 'base/uEditor/uEditor'
import UploadFile from 'base/upload/uploadFileResume'
import PromotionMsg from 'base/promotionMsg/promotionMsg'
import ShalfSetting from 'base/promotionMsg/shalfSetting'
import { getCommonAudioInfo, getShopGroupList, saveCommonAudio} from 'api/api'
// getCommonAudioInfo 音频详情  getShopGroupList 商品分组 saveCommonAudio 音频添加
// import {videoMgtCode} from 'api/enumCode'
import {mapGetters, mapActions} from 'vuex'
import {formatCheckView, formatCheckList, formatFileInfo, computeFileSize} from 'common/js/tools'
import ScrollBox from 'base/scrollBox/scrollBox'
import {videoMsg} from 'api/message'
import $ from 'jquery'
export default {
    name: 'audioEdit',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            // console.log(value)
            if (!value.furl) {
                callback(new Error('请选择音频封面'))
            } else {
                callback()
            }
        }
        let validateVideoInfo = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请上传音频'))
            } else {
                callback()
            }
        }
        let checkOnlineWay = (rule, value, callback) => {
            if (this.item.onlinetype === 2) {
                if (!this.item.onlinetime) {
                    callback(new Error('请选择上架时间'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        return {
            // onlinetypeList: videoMgtCode.onlinetype,
            // feetypeList: videoMgtCode.feetype,
            realName: false,
            shopGroupList: [], // 商品分组
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            uploadVideoType: {
                catecode: '95',
                datatype: 'AUDIO'
            },
            item: {
                innerid: this.$route.query.id ? this.$route.query.id : '', // id
                subject: '', // 音频名称
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }, // 音频封面
                content: '', // 音频详情
                vsource: '1', // 音频来源 1 直接上传 2音频素材
                audioinfo: {
                    duration: '',
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }, // 音频
                // mktype: 1, // 票种营销类型(0 无 1限时优惠 3拼团减价 5 助力减价 6分享解锁)
                // discounttype: 2, // 优惠方式 1折扣减免 2定额减免
                // discountvalue: ', // 优惠数值
                // expirehours: '1', // 完成时间-小时
                // datacond: 1, // 使用条件( 1限时：时间，格式yyyy-MM-dd HH:mm 5 助力减价：好友助力人数，数字，大于0 6分享解锁：分享人数，默认为1)
                onlinetype: 1, // 上架方式
                onlinetime: '', // 定时时间
                divisionids: [],
                isplatform: true,
                ispublic: true
            },
            feetype: 1,
            rules: {
                subject: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                    {min: 1, max: 45, message: '长度在1到45个字符', trigger: 'blur'}
                ],
                coverPicture: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                audioinfo: [
                    {validator: validateVideoInfo, trigger: 'blur'}
                ],
                onlinetype: [
                    {required: true, message: '请选择上架方式', trigger: 'blur'},
                    {validator: checkOnlineWay, trigger: 'blur'}
                ],
                saleprice: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                uprice: [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ]
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: '',
                height: ''
            },
            fileRule: {
                btnName: '选取文件',
                cls: '',
                accept: 'audio/mp3,audio/m4a',
                size: 1 * 500,
                width: '',
                height: ''
            }
        }
    },
    mounted() {
        this._getShopGroupList()
        if (this.item.innerid) {
            this._getView()
        }
    },
    methods: {
        // 跳转商品分组
        goToShopGroup () {
            const _url = window.location.origin
            window.open(`${_url}/shopMgt/goods/goodsGroup`, '_blank')
        },
        // 删除音频
        delUploadVidoe() {
            this.item.audioinfo = {
                duration: '',
                bucket: '',
                fname: '',
                fsize: '',
                width: '',
                height: '',
                key: '',
                mimeType: '',
                objecttype: '',
                furl: ''
            }
        },
        // 打开音频素材库选择框
        openVideoScrollBox() {
            this.$refs.videoScrollBox.openDialog()
        },
        // 设置素材库选择的音频信息
        setMaterialVideofile(file) {
            this.item.vsource = '0'
            this.item.audioinfo = file
        },
        // 打开图片素材库选择框（封面）
        openCoverScrollBox() {
            this.$refs.coverScrollBox.openDialog()
        },
        // 设置素材库选择的图片信息（封面）
        setMaterialCoverfile(file) {
            this.item.coverPicture = file
            this.$refs.coverfile.setImage(this.item.coverPicture.furl)
        },
        // 切换收费/免费
        checkFeetype(val) {
            for (let i in this.item.checkView) {
                this.item.checkView[i].status = false
            }
            this._getShopGroupList()
        },
        // 设置音频信息（本地）
        setFile(file) {
            this.item.vsource = '1'
            this.item.audioinfo = file
        },
        // 设置封面信息（本地）
        setCoverfile(img) {
            this.item.coverPicture = img
        },
        // 获取富文本编辑器内容
        getUEditorContent(content) {
            this.item.content = content
        },
        cancel() {
            this.$confirm(videoMsg.cancelEdit.msg, videoMsg.cancelEdit.title, {
                confirmButtonText: videoMsg.cancelEdit.confirmText,
                cancelButtonText: videoMsg.cancelEdit.cancelText
            }).then(() => {
                this.$router.back()
            }).catch(() => {})
        },
        submitForm() {
            this.$refs.promotionMsg.$refs.sellWayForm.validate((v) => {
                this.$refs.formName.validate((valid) => {
                    if (valid && v) {
                        this.$confirm(videoMsg.submitEdit.msg, videoMsg.submitEdit.title, {
                            confirmButtonText: videoMsg.submitEdit.confirmText,
                            cancelButtonText: videoMsg.submitEdit.cancelText,
                            closeOnClickModal: false
                        }).then(() => {
                            let tmpList = formatCheckList(JSON.parse(JSON.stringify(this.$refs.promotionMsg.item.checkView)))
                            let obj = $.extend(true, {}, Object.assign({}, this.item, this.$refs.promotionMsg.item))
                            obj.checkView = JSON.stringify(tmpList)
                            obj.coverPicture = formatFileInfo(obj.coverPicture)
                            obj.audioinfo = formatFileInfo(obj.audioinfo)
                            // obj.divisionids = JSON.stringify(obj.divisionids)
                            // obj.divisionids = obj.divisionids.join(',')
                            obj.divisionids = obj.divisionids.join(',')
                            obj.isplatform = obj.isplatform ? 1 : 0
                            obj.ispublic = obj.ispublic ? 1 : 0
                            // if (obj.innerid) {
                                // this._editObject(obj)
                            // } else {
                            this._addObject(obj)
                            // }
                        }).catch(() => {
                        })
                    } else {
                        return false
                    }
                })
            })
        },
        _addObject(obj) {
            this.setLoading(true)
            saveCommonAudio({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success(videoMsg.submitEdit.successMsg)
                    this.setLoading(false)
                    this.setPage({page: 1, pageSize: 10})
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取商品分组
        _getShopGroupList () {
            // let obj = {
            //     hostinnerid: this.user.hostinnerid,
            //     totalcount: this.feetype
            // }
            this.setLoading(true)
            getShopGroupList({
                data: {},
                success: data => {
                    this.shopGroupList = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getCommonAudioInfo({
                data: {
                    hostinnerid: this.user.hostinnerid,
                    innerid: this.item.innerid
                },
                success: data => {
                    // data.data.checkView = formatCheckView(JSON.parse(data.data.checkView), this.$refs.promotionMsg.item.checkView)
                    this.item = data.data
                    this.$refs.uEditor.init(this.item.content)
                    this.$refs.promotionMsg.setItem(this.item)
                    this.item.coverPicture = JSON.parse(this.item.coverpicture)
                    // this.item.audioinfo = JSON.parse(this.item.audioinfo)
                    this.item.audioinfo = this.item.audioinfo
                    this.item.isplatform = this.item.isplatform === 1
                    this.item.ispublic = this.item.ispublic === 1
                    this.$refs.coverfile.setImage(this.item.coverPicture.furl)

                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ]),
        changeWay(type) {
            this.feetype = type
        }
    },
    filters: {},
    watch: {
        // 'feetype': {
        //     handler(newFeetype, oldFeetype) {
        //         this._getShopGroupList()
        //     }
        // },
        '$rouer': {

        },
        deep: true,
        immediate: true
    },
    computed: {
        fsize () {
            return function(size) {
                return computeFileSize(size)
            }
        },
        ...mapGetters([
            'loading',
            'user'
        ])
    },
    components: {
        Upload,
        UploadFile,
        UEditor,
        ScrollBox,
        PromotionMsg,
        ShalfSetting
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scpoed>
@import "~common/scss/variable";
@import "~common/scss/mixin";
.audioEdit {
    .el-form-item.share {
        display: none;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        margin-left: 15px;
    }

    .upload-image{
        .el-form-item__content{
            @include flexBox(space-between)
        }
    }
    .account-form{
        margin-top: 20px !important;
    }
    .headImage{
        margin-right: 20px;
        .avatar-uploader{
            box-sizing: border-box;
            width: 320px;
            height: 180px;
        }
    }
    .videoName{
        .el-form-item__content{
            width: 810px;
        }
    }
    .el-upload__tip{
        width: 500px;
        color: $tcolor-grey;
        align-self: center;
        flex-grow: 1;
    }
    .upload-file{
        .upload-display{
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            box-sizing: border-box;
            background: $line;
            display: inline-block;
            border:1px solid rgba(220,223,230,1);
            span+span{
                margin-left: 20px;
            }
        }
        .upload-file-btn{
            @include flexBox(flex-start);
            .uploadFile{
                margin-right: 20px;
            }
        }
    }
    .shopGroup{
        .el-select{
            width: 278px;
        }
        .el-button{
            min-width: 0px;
            margin-right: 10px;
        }
        .refresh{
            margin-left: 12px;
        }
    }
}
</style>
